import React from 'react';
import {
  IItemCreationSubsectionInputProps,
  ItemCreationFieldValue,
  ItemCreationSubsection,
} from '~/Components';
import { ExtendedLocation } from '../ExtendedLocation.model';
import { LocationEditCustomQRCode } from './LocationEditCustomElements';
import { LocationEditCustomQRCodeFlyer } from './LocationEditCustomElements/LocationEditCustomQRCodeFlyer';
import { useHasAccess } from '~/Hooks';
import { AccessList } from '~/Hooks/useHasAccess/accessList.types';
import { useRouteMatch } from 'react-router-dom';
import { Route } from '~/Constants/Routes.constants';
import { LocationEditCustomWelcomePack } from './LocationEditCustomElements/LocationEditCustomWelcomePack';

export const LocationEditOtherSection = (
  extendedLocation: ExtendedLocation,
  setFieldValue: ItemCreationFieldValue,
) => {
  const { hasAccess } = useHasAccess();
  const isCreateRoute = useRouteMatch({ path: Route.PROVIDER_LOCATIONS_CREATE });

  const LocationEditOtherDetails: IItemCreationSubsectionInputProps<Partial<ExtendedLocation>>[] = [
    {
      customElement: (
        <LocationEditCustomQRCode
          extendedLocation={extendedLocation}
          isCreateRoute={isCreateRoute?.isExact}
        />
      ),
      customElementFullSection: true,
    },
  ];

  const LocationEditOtherDetailsRestricted: IItemCreationSubsectionInputProps<
    Partial<ExtendedLocation>
  >[] = [
    {
      customElement: (
        <LocationEditCustomWelcomePack location={extendedLocation} setFieldValue={setFieldValue} />
      ),
      customElementFullSection: true,
    },
    {
      customElement: <LocationEditCustomQRCodeFlyer />,
      customElementFullSection: true,
      noBorder: true,
    },
  ];

  if (hasAccess(AccessList.LOCATION_WELCOME_PACKAGE) && isCreateRoute?.isExact) {
    LocationEditOtherDetails.unshift(...LocationEditOtherDetailsRestricted);
  }

  return <ItemCreationSubsection items={LocationEditOtherDetails} noBorder />;
};
